/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

import React from 'react';
import { SituationsAndSymptomsKeys } from '../../../../models/situationsAndSymptoms';
import SituationAndSymptoms from '../SituationAndSymptoms/SituationAndSymptoms';
import { NodeType } from '../../../../backendModels/report.model';
import { CardId } from '../../../../models/diviCard';

const generalConditionKeys = [
  SituationsAndSymptomsKeys.zuvorGesund,
  SituationsAndSymptomsKeys.zuvorLeichtEingeschraenkt,
  SituationsAndSymptomsKeys.zuvorDeutlichEingeschraenkt,
  SituationsAndSymptomsKeys.zuvorAkutLebensgefaehrdet,
  SituationsAndSymptomsKeys.zuvorMoribund,
];

export interface GeneralConditionProps {
  readonly nodeType: NodeType;
}

export default function GeneralCondition({ nodeType }: GeneralConditionProps) {
  return (
    <SituationAndSymptoms
      nodeType={nodeType}
      situationAndSymptomsKeys={generalConditionKeys}
      cardId={CardId.GeneralCondition}
    />
  );
}
